import React, {Component, Fragment} from 'react';
import Footer from "../components/Footer";
import Header from "../components/Header";
import Constants from '../inc/Constants';
import PlaceListItem from './gmaps/PlaceListItem';
import PlaceDescItem from './gmaps/PlaceDescItem';
import axios from "axios";
import {ListGroup, Nav} from 'reactstrap';
import CbsData from './cbs/CbsData'
import HeaderFooterHOC from '../HOC/HeaderFooterHOC';
import LangContext from "../providers/LangContext";
import MapContainer from "./gmaps/MapContainer";
import {faInfoCircle} from "@fortawesome/pro-light-svg-icons/faInfoCircle";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

class InDeBuurt extends Component {

    static contextType = LangContext;

	constructor(props) {
		super(props);

		this.state = {
			active: '',
			showingInfoWindow: false,
			nearbyPlaces: {},
			mapCenter: {},
			selectedPlace: '',
			mainAddress: {},
			mapObject: {},
		};

		this.selectItem = this.selectItem.bind(this);
		this.isActive = this.isActive.bind(this);
		this.onMarkerClick = this.onMarkerClick.bind(this);
		this.onDescriptionClick = this.onDescriptionClick.bind(this);
		this.onInfoWindowClose = this.onInfoWindowClose.bind(this);
		this.onMapClicked = this.onMapClicked.bind(this);
	}

	componentDidMount() {
		if(!this.props.latLng) {
			return;
		}
		const center = this.props.latLng.split(',');
		let self = this;

		this.setState({
			mapCenter: {
				lat: parseFloat(center[0]),
				lng: parseFloat(center[1])
			},
			mainAddress: {
				lat: parseFloat(center[0]),
				lng: parseFloat(center[1])
			}
		});

	}

    componentDidCatch(error, errorInfo) {
	    return false;
    }

    selectItem(key) {
		let active = this.state.active;
		let self = this;
		if (this.state.active === key) {
			active = '';
			this.setState({nearbyPlaces: {}, mapCenter: this.state.mainAddress});
		} else {
			active = key;
			axios.get('/api/site/' + this.props.siteID + '/place', {
				params: {
					place: active
				}
			}).then((response) => {
				self.setState({nearbyPlaces: response.data.places});
			}).catch((error) => {

			});
		}
		this.setState({active: active});
	}

	isActive(key) {
		return this.state.active === key;
	}

	onMarkerClick = (e, marker) => {
		this.setState({
			selectedPlace: marker,
			showingInfoWindow: true
		});
	};

	onDescriptionClick = (e, marker, latLng) => {
		this.setState({
			selectedPlace: marker,
			showingInfoWindow: true,
			mapCenter: latLng
		});
	};

	onInfoWindowClose = () => {
		this.setState({
			selectedPlace: '',
			showingInfoWindow: false,
			mapCenter: this.state.mainAddress
		});
	};

	onMapClicked = (props) => {
		if (this.state.showingInfoWindow) {
			this.setState({
				selectedPlace: '',
				showingInfoWindow: false,
				mapCenter: this.state.mainAddress
			});
		}
	};

	render() {
		let lang = this.context.lang;
		const latLng = (this.props.latLng.length > 1) ? this.props.latLng.split(',') : false;

		if(!this.props.latLng) {
			return (
				<div>
					<Header
                        title={this.props.title}
                        subTitle={this.props.page.title}
						background_image={this.props.page.background_image}
						background_image_id={this.props.page.background_image_id}
						fallbackBackgroundImage={ this.props.fallbackBackgroundImage }
					/>
					<div className="container content" >
						<h3>De informatie over de buurt kan momenteel niet worden opgehaald.</h3>
					</div>
					<CbsData siteID={this.props.siteID}/>
					<Footer footerHtmlText={this.props.footerHtmlText} theme={this.props.theme}/>
				</div>
			);
		}
		return (
            <Fragment>
					{!!latLng && <MapContainer
                        mainAddress={this.state.mainAddress}
						mapCenter={this.state.mapCenter}
						nearbyPlaces={this.state.nearbyPlaces}
						onMarkerClick={this.onMarkerClick}
						onInfoWindowClose={this.onInfoWindowClose}
						onMapClicked={this.onMapClicked}
						selectedPlace={this.state.selectedPlace}
						getMapObject={this.getMapObject}
						hidden_address={this.props.hidden_address}
						theme={this.props.theme}
					/>}
					<br/>

                    {!!this.props.hidden_address &&
                        <div className="alert alert-primary" role="alert">
                            <FontAwesomeIcon icon={faInfoCircle} /> {lang.get('sites.randomized_lat_lng_explanation')}
                        </div>
                    }

					{!!latLng && <div id="places-select">
						<Nav pills id="hs-places-list">
							{Object.keys(Constants.PLACETYPES).map(function (key, index) {
								let active = this.isActive(key);
								return <PlaceListItem
									key={key}
									name={key}
									niceName={lang.get(`sites.${key}`)}
									active={active}
									selectItem={this.selectItem}
								/>
							}, this)}
						</Nav>
					</div>}
					<div id="selected-places-container" >
						{(this.state.active !== '' && this.state.nearbyPlaces.length > 0) && this.state.nearbyPlaces.map((place, index) => <ListGroup flush key={'selected-place-' + place.id}>
                            <PlaceDescItem
                                placeId={place.id}
                                name={place.displayName.text}
                                address={place.shortFormattedAddress}
                                onDescriptionClick={this.onDescriptionClick}
                                latLng={{lat: place.location.latitude, lng: place.location.longitude}}
                            />
                        </ListGroup>)}
					</div>
				{/*<CbsData*/}
				{/*	siteID={this.props.siteID}*/}
				{/*	theme={this.props.theme}*/}
				{/*/>*/}
		</Fragment>
		)
	}
}

export default HeaderFooterHOC(InDeBuurt);


